mutation ResolveContactDifferences(
  $attendeeId: ID!
  $updateSalesforce: [EventContactFieldEnum!]
  $useSalesforce: [EventContactFieldEnum!]
  $dismiss: [EventContactFieldEnum!]
) {
  resolveContactDifferences(
    input: {
      attendeeId: $attendeeId
      updateSalesforce: $updateSalesforce
      useSalesforce: $useSalesforce
      dismiss: $dismiss
    }
  ) {
    attendee {
      id
    }
  }
}
